export default "Daniela byla skvělý hostitel. Okamžitě reagovala na všechny zprávy a dotazy. Ubytování je moc krásné a perfektně čisté. Moc doporučuji. :)";